import React from 'react';
import { t } from '../../translation';

interface LoadingBarProps {
    progress: number; // 0-100
    isVisible: boolean;
    message?: string;
}

class LoadingBar extends React.Component<LoadingBarProps> {
    render() {
        const { progress, isVisible, message } = this.props;

        if (!isVisible) return null;

        return (
            <div className="loading-overlay">
                <div className="loading-container">
                    <div className="loading-content">
                        <div className="loading-logo">
                            <img src="/static/Logo_VYSIA_White_Fluor.png" alt="Vysia" />
                        </div>
                        <div className="loading-text">
                            {message || t('app.loading')}
                        </div>
                        <div className="progress-container">
                            <div className="progress-bar">
                                <div 
                                    className="progress-fill" 
                                    style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
                                ></div>
                            </div>
                            <div className="progress-text">
                                {Math.round(Math.min(100, Math.max(0, progress)))}%
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default LoadingBar;